
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/high-performance-postgresql-for-rails",
      function () {
        return require("private-next-pages/books/high-performance-postgresql-for-rails.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/high-performance-postgresql-for-rails"])
      });
    }
  